import { CastColor as CastColorOriginal } from "../../generated/graphql";
import { CamelCasedType } from "../components";

export type CastColor = CamelCasedType<CastColorOriginal>;

export interface ColorObj {
  backgroundColor?: string;
  color?: string;
  fontFamily?: string;
}

// Deprecated
export function colorHelperBase(colorBg: CastColor, colorFg: CastColor) {
  return {
    backgroundColor: `rgba(${colorBg?.red},${colorBg?.green},${colorBg?.blue},${colorBg?.alpha})`,
    color: `rgba( ${colorFg?.red},${colorFg?.green},${colorFg?.blue},${colorFg?.alpha})`,
  };
}

function normalizeFontFamilies(fontFamilyString: Array<string | null>) {
  if (!fontFamilyString || fontFamilyString?.length === 0) return [];
  const newFontFamilyString: Array<string | null> = [];
  let replaced = "";
  for (const fontFamily of fontFamilyString) {
    if (!fontFamily) {
      newFontFamilyString.push(null);
    } else {
      replaced = fontFamily.replaceAll("san serif", "sans-serif"); //correct a typo in the old code
      for (const oldFont of ["Futura PT", "Futura Lt BT"]) {
        replaced = replaced.replaceAll(oldFont, "Jost Variable");
      }
      newFontFamilyString.push(
        replaced.replaceAll("VAG Rounded Regular", "Nunito Variable")
      );
    }
  }
  return newFontFamilyString;
}

export const parseColorToStyle = (
  params: {
    backgroundColor?: CastColor | null;
    foregroundColor?: CastColor | null;
    fontFamily?: (string | null)[] | null;
  } | null = {}
): ColorObj => {
  const { backgroundColor, foregroundColor, fontFamily } = params || {};

  return {
    backgroundColor: backgroundColor
      ? `rgba(${backgroundColor.red},${backgroundColor.green},${backgroundColor.blue},${backgroundColor.alpha})`
      : "",
    color: foregroundColor
      ? `rgba(${foregroundColor.red},${foregroundColor.green},${foregroundColor.blue},${foregroundColor.alpha})`
      : "",
    fontFamily:
      !fontFamily || fontFamily.every((element) => element === null)
        ? undefined
        : normalizeFontFamilies(fontFamily).join(","),
  };
};
